import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const AnalyticsDashboardContainer = React.lazy(
  () => import('../../containers/analytics-dashboard/analytics-dashboard.container')
);
const RawEntriesContainer = React.lazy(
  () => import('../../containers/raw-entries/raw-entries.container')
);
const ProcessedDataContainer = React.lazy(
  () => import('../../containers/processed-data/processed-data.container')
);

const permittedRoles = [UserRole.ADMIN, UserRole.HR_REPRESENTATIVE, UserRole.HR_MANAGER];

export const AttendanceRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={APP_ROUTES.ATTENDANCE_DASHBOARD.FULL_PATH} />
  },
  {
    path: 'dashboard',
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={permittedRoles}
          component={AnalyticsDashboardContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: 'raw-entries',
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={permittedRoles}
          component={RawEntriesContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: 'processed-data',
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={permittedRoles}
          component={ProcessedDataContainer}
        />
      </React.Suspense>
    )
  }
];
